import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const reasons = [
  {
    icon: 'ri-links-line',
    title: 'Reliable Supplier Network Across China',
    description:
      'Established relationships with vetted manufacturers and suppliers across key industrial hubs in China — ensuring quality, consistency, and competitive pricing.',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Competitive Pricing Through Direct Sourcing',
    description:
      'By working directly with manufacturers and bypassing unnecessary intermediaries, we secure the most cost-effective pricing for large-scale orders.',
  },
  {
    icon: 'ri-route-line',
    title: 'End-to-End Solutions From Sourcing to Delivery',
    description:
      'We handle the entire supply chain — from product identification and factory negotiation to quality control, export documentation, and final delivery.',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Experience With Large-Scale Projects',
    description:
      'Proven track record with multi-floor hotel developments, villa complexes, and major vehicle export programs requiring precision coordination.',
  },
  {
    icon: 'ri-global-line',
    title: 'Deep Understanding of International Markets',
    description:
      'Fluent in the regulatory, cultural, and logistical requirements of East African and Middle Eastern markets — ensuring smooth cross-border operations.',
  },
];

export default function WhyChooseUs() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="why" className="py-32 bg-charcoal-light">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16">
          {/* Left Sticky Heading */}
          <div
            ref={ref}
            className={`lg:col-span-2 transition-all duration-900 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <span className="text-gold text-[10px] font-semibold tracking-[0.35em] uppercase mb-5 block">
              Our Advantage
            </span>
            <h2 className="font-heading text-4xl md:text-5xl font-light text-white leading-tight">
              Why Partner<br />
              With <em className="not-italic text-gold">ABUMI</em>
            </h2>
            <div className="section-divider mt-6 mb-8" />
            <p className="text-[#7A7A7A] text-sm leading-relaxed tracking-wide">
              We are not a trading platform. We are your dedicated partner — bringing years of cross-border expertise, vetted supplier access, and on-the-ground experience to every deal.
            </p>

            {/* Large decorative number */}
            <div className="mt-12 font-heading text-[120px] font-light text-charcoal-border leading-none select-none">
              5
            </div>
            <div className="text-[10px] text-charcoal-text tracking-[0.2em] uppercase -mt-4">
              Key Advantages
            </div>
          </div>

          {/* Right: Reasons */}
          <div className="lg:col-span-3 flex flex-col gap-0">
            {reasons.map((reason, i) => (
              <div
                key={reason.title}
                className={`flex gap-6 py-8 border-b border-charcoal-border last:border-b-0 group transition-all duration-700 ${
                  isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'
                }`}
                style={{ transitionDelay: `${100 + i * 120}ms` }}
              >
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center border border-charcoal-border group-hover:border-gold/40 transition-colors duration-300 mt-1">
                  <i className={`${reason.icon} text-gold text-lg`} />
                </div>
                <div>
                  <h3 className="text-white text-sm font-semibold tracking-wide mb-2 group-hover:text-gold transition-colors duration-300">
                    {reason.title}
                  </h3>
                  <p className="text-[#7A7A7A] text-sm leading-relaxed tracking-wide">
                    {reason.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
